import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DataShare } from 'src/app/services/datashare';
import { MainService } from 'src/app/services/main.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-provider-terms-conditions',
  templateUrl: './provider-terms-conditions.component.html',
  styleUrls: ['./provider-terms-conditions.component.css'],
})
export class ProviderTermsConditionsComponent implements OnInit {
  jsonData: any;
  posts: any;
  version: any;
  constructor(
    private mainService: MainService,
    private router: Router,
    private dataShare: DataShare,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.mainService.getBappTermsData().subscribe((res: any) => {
      var doc: any = new DOMParser().parseFromString(
        res[0].content,
        'text/html'
      );
      this.version = res[0].versionId;
      this.jsonData = this.sanitizer.bypassSecurityTrustHtml(
        doc.firstChild.innerHTML
      );
    });
  }
  onReturnToLogin() {
    this.router.navigate(['/provider/login']);
  }
  onTermsAccept() {
    this.dataShare.setTouAccepted(
      new DatePipe('en-US').transform(new Date(), 'MM-dd-yyyy')
    );
  }
}
